import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaPhoneAlt, FaUser } from "react-icons/fa";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import MakeOfferModal from "../modals/MakeOfferModal";
import LcaCardQuestions from "./LcaCardsQuestions";
import LcaCardsEvents from "./LcaCardsEvents";
import "./LcaCards.css";
import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data";
import CarouselComponent from "./BizzList";
import { initiateCall, makeCall, sendMsgMail } from "../Data";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import { setSelectedAd, setSkippedAd } from "../../../redux/slices/LcaSlice";
import { MdGroups } from "react-icons/md";
import GitHubForkRibbon from "react-github-fork-ribbon";
import { Grid, IconButton, Tooltip } from "@mui/material";
import SkipModal from "./SkipModal";
import axiosClient from "../../../axios-client";
import { BsInfoCircleFill } from "react-icons/bs";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsChatModalOpen,
  setIsMsgModalOpen,
  setSampleAd,
  setSearchPopUp,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { setLoginPopUp } from "../../../redux/slices/settingSlice";

const LcaBox = ({ ad }) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [schedule, setSchedule] = useState(false);
  const navigate = useNavigate();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipRef = useRef();
  const buttonRef = useRef();
  const [questionsVisible, setQuestionsVisible] = useState({});
  const [eventsVisible, setEventsVisible] = useState({});
  const [imageIndex, setImageIndex] = useState({});
  const { myOffers, selectedAd } = useSelector((state) => state.lcAds);
  const {
    sampleAd,
    isMsgModalOpen,
    actionClickStatus,
    actionClickError,
    checkExistingError,
    checkExistingStatus,
  } = useSelector((state) => state.searchBar);
  const [openSkipModal, setOpenSkipModal] = useState(false);
  const isAdmin = user && user.Role === "admin"; // Check if user is admin
  const logUser = localStorage.getItem("USER_ROLE");
  const isVendor = logUser === "provider";
  const { isChatModalOpen } = useSelector((state) => state.searchBar);
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setTooltipOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const isExist = async () => {
    if (islogin) {
      const checkForm = {
        Title: ad?.Title + " (Auto Generated)",
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      if (result.data) {
        setPhoneButton(`(800)245-3610 Ext# ${ad.dialExtension}`);
      }
    }
  };
  useEffect(() => {
    isExist();
  }, [ad]);
  const isAdInMyOffers = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    console.log(parseIds, "parseIds");
    return parseIds?.includes(user?.UserID);
  };
  console.log(ad, "ewrgthjhgfd");
  const isAlreadyGotton = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.length >= 5;
  };

  const handleCardClick = (selectedCard) => {
    const screenWidth = window.innerWidth;
    const isIpadPro = screenWidth === 1024;
    if (!isMsgModalOpen && !isOfferModalOpen) {
      if (selectedCard.engagedCouple === 1) {
        if (isIpadPro) {
          navigate(`/engagedCouple/${selectedCard.createdBy}`);
        } else {
          window.open(`#/engagedCouple/${selectedCard.createdBy}`, "_blank");
        }
      } else {
        if (isIpadPro) {
          navigate(`/requestDetails/${selectedCard.Id}`);
        } else {
          window.open(`#/requestDetails/${selectedCard.Id}`, "_blank");
        }
      }
    }
  };
  const closeModal = () => {
    dispatch(setIsChatModalOpen(false));
    setIsOfferModalOpen(false);
    dispatch(setSampleAd(null));
    setSchedule(false);
  };
  const openOfferModal = (event, ad) => {
    event.stopPropagation();
    if (!islogin) {
      toast.info("Please Login To Get Customer!..");
    } else {
      setIsOfferModalOpen(true);
      dispatch(setSelectedAd(ad));
    }
  };

  function formatDate1(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  const now = new Date();
  const formattedDate = formatDate1(now);
  const handleGroupCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.alternativePhoneOne,
        countryCode:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.alternativePhoneTwo,
        countryCode:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
    };
    console.log(phoneDetailsObj, "phoneDetailsObj");
    toast.success("Group Call Started");
    await initiateCall(formData);
  };
  const handleIndiviualCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
    };
    console.log(phoneDetailsObj, "phoneDetailsObj");
    toast.success("Call Started");
    await initiateCall(formData);
  };
  const toggleQuestions = (event, ad) => {
    event.stopPropagation();
    const currentQuestionsVisible = questionsVisible[ad.Id] || false;
    const currentEventsVisible = eventsVisible[ad.Id] || false;
    if (currentEventsVisible) {
      setEventsVisible({ ...eventsVisible, [ad.Id]: false });
    }
    const updatedQuestionsVisible = {};
    Object.keys(questionsVisible).forEach((cardId) => {
      updatedQuestionsVisible[cardId] =
        cardId === ad.Id ? !currentQuestionsVisible : false;
    });
    setQuestionsVisible({
      ...updatedQuestionsVisible,
      [ad.Id]: !currentQuestionsVisible,
    });
  };
  function convertTo12HourFormat(time24) {
    if (!time24) {
      return "";
    }
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) {
      return "";
    }
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0");
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  function formatDate(inputDate) {
    let date = new Date(inputDate);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    let formattedDay = day < 10 ? "0" + day : day;
    let formattedDate = `${month} ${formattedDay}, ${year}`;
    return formattedDate;
  }

  const toggleEvents = (event, ad) => {
    event.stopPropagation();
    const currentQuestionsVisible = questionsVisible[ad.Id] || false;
    const currentEventsVisible = eventsVisible[ad.Id] || false;
    if (currentQuestionsVisible) {
      setQuestionsVisible({ ...questionsVisible, [ad.Id]: false });
    }
    const updatedEventsVisible = {};
    Object.keys(eventsVisible).forEach((cardId) => {
      updatedEventsVisible[cardId] =
        cardId === ad.Id ? !currentEventsVisible : false;
    });
    setEventsVisible({
      ...updatedEventsVisible,
      [ad.Id]: !currentEventsVisible,
    });
  };

  function convertToUserTimezone(utcTime) {
    let timezone = "America/Los_Angeles";
    if (islogin && user?.TimeZone) {
      timezone = user?.TimeZone.split(",")[0];
    }
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    return localTime;
  }

  const handleNextImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const nextIndex = (currentIndex + 1) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: nextIndex });
  };

  const handlePrevImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: prevIndex });
  };

  const [timeLeft, setTimeLeft] = useState(null);
  const [isOneHourLeft, setIsOneHourLeft] = useState(false);
  useEffect(() => {
    const adCreationTime = new Date(ad.approvedAt);
    const currentTime = new Date();
    const timeDifference = currentTime.getTime() - adCreationTime.getTime();

    if (timeDifference > 24 * 60 * 60 * 1000) {
      setTimeLeft("00:00:00");
    } else {
      const remainingTime = 24 * 60 * 60 * 1000 - timeDifference;
      const hours = Math.floor(remainingTime / (60 * 60 * 1000));
      const minutes = Math.floor(
        (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
      );
      const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

      setTimeLeft(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );

      setIsOneHourLeft(hours <= 1);
    }

    const intervalId = setInterval(() => {
      const adCreationTime = new Date(ad.approvedAt);
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - adCreationTime.getTime();

      if (timeDifference > 24 * 60 * 60 * 1000) {
        setTimeLeft("00:00:00");
      } else {
        const remainingTime = 24 * 60 * 60 * 1000 - timeDifference;
        const hours = Math.floor(remainingTime / (60 * 60 * 1000));
        const minutes = Math.floor(
          (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
        );
        const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

        setTimeLeft(
          `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        );

        setIsOneHourLeft(hours <= 1);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [ad.createdAt]);

  const handleSkip = async (event, ad) => {
    event.stopPropagation();
    if (!islogin) {
      toast.info("Please Login To Skip Customer!..");
      return;
    }
    if (ad?.needSkipCustomer == 0) {
      dispatch(setSelectedAd(ad));
      setOpenSkipModal(true);
    } else {
      const updatedAd = { ...ad, needSkipCustomer: 0 };
      dispatch(setSkippedAd(updatedAd)); // Optimistic update

      try {
        const formData = {
          needId: ad.Id,
          skipStatus: 0,
          createdBy: user?.UserID,
        };
        const response = await axiosClient.post(
          "need/UndoSkipCustomer",
          formData
        );
        if (response.data.statusCode === 200) {
          toast.success("Ad unskipped successfully!");
        } else {
          dispatch(setSkippedAd(ad)); // Revert on failure
          toast.error(response.data.msg || "Failed to unskip ad");
        }
      } catch (error) {
        dispatch(setSkippedAd(ad)); // Revert on error
        toast.error("Error unskipping ad");
        console.error("Error:", error);
      }
    }
  };
  React.useEffect(() => {
    if (actionClickStatus === "failed" && actionClickError) {
      toast.error(actionClickError);
    }
  }, [actionClickStatus, actionClickError]);
  React.useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);
  const handleAction = async (event, action) => {
    event.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));

    if (!islogin) {
      toast.info("Please Login");
      dispatch(setLoginPopUp(true));
      return;
    }
    const constructedTitle = ad?.Title + " (Auto Generated)";
    const checkForm = {
      Title: constructedTitle,
      userId: user.UserID,
    };

    const result = await dispatch(checkExisting(checkForm)).unwrap();
    const needExists = result.data; // Extract the 'data' field (true/false)
    console.log(needExists, "needExists");

    if (isAdmin || isVendor || needExists) {
      // Admins and vendors bypass the checkExisting API and perform the action directly
      if (action === "CALL") {
        const phoneNumber = "8002453610";
        const url = `tel:${phoneNumber}`;
        window.location.href = url;
      } else if (action === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      return;
    }
    const actionForm = {
      userId: user.UserID,
      postId: ad.Id,
      postType: 1,
      clickType: action === "CALL" ? 1 : action === "TEXT" ? 2 : 3,
      createdBy: user.UserID,
    };
    dispatch(handleActionClick(actionForm));
    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(0));
  };
  return (
    <>
      {" "}
      <Card className="shadow-sm position-realtive">
        {ad?.caIdStatus === 100 ? (
          <GitHubForkRibbon color="green" position="left">
            Verified & Trusted
          </GitHubForkRibbon>
        ) : null}
        <Row className="g-0">
          <div
            className="position-absolute"
            style={{
              backgroundColor: "white",
              width: "auto",
              padding: "0 3px 3px 0",
            }}
          >
            <img
              className=""
              style={{
                width: "30px",
              }}
              src={ad?.profilePhoto ? ad?.profilePhoto : PlaceHolder}
              alt={ad?.firstName}
            />
          </div>
          <Col lg="3" md="3" className="d-flex align-items-center ">
            <div className="position-relative">
              {ad.Photo && JSON.parse(ad.Photo).length > 1 && (
                <button
                  className="arrow left-arrow position-absolute"
                  style={{
                    top: "50%",
                    left: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                    fontSize: "30px",
                    zIndex: 1,
                  }}
                  onClick={(event) => handlePrevImage(event, ad)}
                >
                  ❮
                </button>
              )}
            </div>
            <img
              className="wc_egcpl-ad img-fluid"
              src={
                ad.Photo && JSON.parse(ad.Photo).length > 0
                  ? JSON.parse(ad.Photo)[imageIndex[ad.Id] || 0]
                  : PlaceHolder
              }
              alt={ad.Title}
              style={{
                objectFit: "fill",
                height: "220px",
                width: "220px",
              }}
            />
            <div className="position-relative">
              {ad.Photo && JSON.parse(ad.Photo).length > 1 && (
                <button
                  className="arrow right-arrow position-absolute"
                  style={{
                    top: "50%",
                    right: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                    fontSize: "30px",
                    zIndex: 1,
                  }}
                  onClick={(event) => handleNextImage(event, ad)}
                >
                  ❯
                </button>
              )}
            </div>
          </Col>
          <Col lg="7" md="7">
            <CardBody
              onClick={() => handleCardClick(ad)}
              className="lca-card-body"
            >
              <CardTitle
                tag="h5"
                className="mb-2"
                style={{
                  fontSize: "large",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <b>
                  {" "}
                  {ad.Title.length > 100
                    ? `${ad.Title.substring(0, 100)}...`
                    : ad.Title}
                </b>
              </CardTitle>
              <CardText
                style={{
                  fontSize: "medium",
                  marginLeft: 0,
                }}
              >
                {ad.Description.length > 200
                  ? `${ad.Description.substring(0, 200)}...`
                  : ad.Description}
              </CardText>
              <div className="d-lg-flex">
                <CardText
                  className="text-nowrap mx-0"
                  style={{ fontSize: "medium" }}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span> {ad.Zipcode}</span> -{" "}
                  <span className=""> {ad.placeName}</span>
                </CardText>
                {ad.categoryName && (
                  <CardText className="" style={{ fontSize: "medium" }}>
                    <b>Service Needed:</b>{" "}
                    {ad.categoryName
                      ? ad.categoryName
                      : ad.subCategoryName
                      ? ad.subCategoryName
                      : ad.itemName
                      ? ad.itemName
                      : ""}
                  </CardText>
                )}
              </div>
              <div>
                <p className="mb-0 posting" style={{ fontSize: "small" }}>
                  Posting Date/Time:{" "}
                  {formatDate(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[0]
                  )}
                   
                  {convertTo12HourFormat(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[1]
                  )}
                </p>
              </div>
            </CardBody>
          </Col>
          <Col
            lg="2"
            md="2"
            className="d-flex flex-column align-items-center justify-content-center"
          >
            {ad.engagedCouple == 1 && (
              <div className="w-100 text-center engagedCouple">
                {isAdInMyOffers(ad) ? (
                  <>
                    <span className="dropdown-center">
                      <Button
                        color="success"
                        size="sm"
                        className="dropdown-toggle w-100 mb-2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Call Me
                      </Button>
                      <ul
                        className="dropdown-menu dropdown-menu-center"
                        style={{ cursor: "pointer" }}
                      >
                        <li>
                          <a
                            class="dropdown-item text-center fw-bold"
                            onClick={() => handleIndiviualCall(ad)}
                          >
                            Individual Call <FaUser />
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-center fw-bold"
                            onClick={() => handleGroupCall(ad)}
                          >
                            Group Call <MdGroups size={20} />
                          </a>
                        </li>
                      </ul>
                    </span>
                    <Button
                      color="primary"
                      size="sm"
                      className="w-100 mb-2"
                      onClick={(event) => handleAction(event, "TEXT")}
                      // onClick={(event) => openOfferModal(event, ad)}
                      // onClick={(event) => openMsgModal(event, ad)}
                    >
                      Send message
                    </Button>
                  </>
                ) : isAlreadyGotton(ad) ? (
                  <Button
                    color="primary"
                    size="xs"
                    className="w-100 mb-2"
                    disabled
                  >
                    Other venues took customer
                  </Button>
                ) : (
                  <>
                    <Button
                      color="primary"
                      size="sm"
                      className="w-100 mb-2"
                      onClick={(event) => openOfferModal(event, ad)}
                    >
                      Get Customer!
                      <br />
                      {islogin && (
                        <>
                          {timeLeft === "00:00:00" ? (
                            <p
                              className="text-white m-0 text-nowrap"
                              style={{ fontSize: "12px" }}
                            >
                              Late Fee $10
                            </p>
                          ) : (
                            <div className="d-flex align-items-center justify-content-center">
                              <p
                                className="m-0"
                                style={{
                                  fontSize: "small",
                                  color:
                                    // isOneHourLeft || timeLeft === "00:00:00"
                                    //   ? "#9d0707"
                                    //   :
                                    "white",
                                  textWrap: "nowrap",
                                }}
                              >
                                {timeLeft === "00:00:00"
                                  ? `Time's Up: ${timeLeft}`
                                  : `Time left: ${timeLeft}`}
                              </p>
                              <button
                                id="ScheduleUpdateTooltip"
                                ref={buttonRef}
                                className="ms-2 position-relative"
                                style={{
                                  backgroundColor: "inherit",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTimeout(() => {
                                    setTooltipOpen(true);
                                  }, 0); // or 50ms if needed
                                }}
                              >
                                <BsInfoCircleFill size={17} />
                              </button>
                              <UncontrolledTooltip
                                placement="top"
                                target="ScheduleUpdateTooltip"
                                trigger="click"
                                isOpen={tooltipOpen}
                                toggle={() => setTooltipOpen(false)}
                                container="body"
                                innerRef={tooltipRef} // Adding ref to tooltip
                              >
                                Free during 24-hour timer, $10 late fee applies
                                after
                              </UncontrolledTooltip>

                              {/* <span
                                style={{ fontSize: "small", textWrap: "wrap" }}
                              >
                                *(Free until the timer ends. After that, it's
                                $10.)
                              </span> */}
                            </div>
                          )}
                        </>
                      )}
                    </Button>
                    <Button
                      color={ad?.needSkipCustomer == 1 ? "secondary" : "danger"}
                      size="sm"
                      className="w-100 mb-2"
                      onClick={(e) => handleSkip(e, ad)}
                    >
                      {ad?.needSkipCustomer == 1 ? "Unskip" : "Skip"}
                    </Button>
                  </>
                )}
                <Button
                  color={questionsVisible[ad.Id] ? "secondary" : "warning"}
                  size="sm"
                  className="w-100 mb-2"
                  onClick={(event) => toggleQuestions(event, ad)}
                >
                  {questionsVisible[ad.Id] ? "Hide Q&A" : "Show Q&A"}
                </Button>
                <Button
                  color={eventsVisible[ad.Id] ? "secondary" : "success"}
                  size="sm"
                  className="w-100"
                  onClick={(event) => toggleEvents(event, ad)}
                >
                  {eventsVisible[ad.Id]
                    ? "Hide Event Details"
                    : "Show Event Details"}
                </Button>
              </div>
            )}
            {ad.engagedCouple != 1 && ad?.checkedValue === "mobile" ? (
              <div className="w-100 text-center need">
                {islogin ? (
                  <a
                    onClick={(event) => handleAction(event, "CALL")}
                    className="btn btn-success btn-sm mb-2 w-100"
                  >
                    <FaPhoneAlt /> {phoneButton}
                    {/* (800)245-3610 <br />
                  <span>Ext# {ad.dialExtension}</span> */}
                  </a>
                ) : (
                  <button
                    className="btn btn-success btn-sm mb-2 w-100"
                    onClick={() => toast.info("Please Login")}
                  >
                    {phoneButton}
                  </button>
                )}

                <Button
                  color="primary"
                  size="sm"
                  className="w-100"
                  onClick={(event) => handleAction(event, "TEXT")}
                  // onClick={(event) => openMsgModal(event, ad)}
                >
                  Send Message
                </Button>
              </div>
            ) : (
              ad.engagedCouple != 1 &&
              ad?.checkedValue === "website" && (
                <button
                  className={`btn btn-sm`}
                  style={{ backgroundColor: "#99d9ea" }}
                  onClick={(event) => handleAction(event, "VISIT")}
                >
                  <a
                    // href={ad?.websiteLink}
                    target="_blank"
                    className="text-dark"
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      padding: "3px 7px",
                    }}
                  >
                    Visit Webpage
                  </a>
                </button>
              )
            )}
          </Col>
        </Row>

        {questionsVisible[ad.Id] && (
          <CardBody>
            <LcaCardQuestions ad={ad} />
          </CardBody>
        )}
        {eventsVisible[ad.Id] && (
          <CardBody>
            <LcaCardsEvents ad={ad} />
          </CardBody>
        )}
      </Card>
      {isOfferModalOpen && (
        <MakeOfferModal
          isOpen={isOfferModalOpen}
          closeModal={closeModal}
          selectedCard={selectedAd}
          setSchedule={setSchedule}
          schedule={schedule}
          timeLeft={timeLeft}
        />
      )}
      {openSkipModal && (
        <SkipModal
          open={openSkipModal}
          close={() => setOpenSkipModal(false)}
          ad={ad}
        />
      )}
    </>
  );
};

export default LcaBox;
